import { cn } from "../../lib/utils";

export interface ThumbProps {
  src?: string | null;
  alt: string;
  size?: string;
  className?: string;
}

/** Miniatura com fundo xadrez (.thumb) quando nao ha foto. */
export function Thumb({ src, alt, size = "3.25rem", className }: ThumbProps): JSX.Element {
  return (
    <span
      className={cn("thumb", className)}
      style={{ width: size, height: size, display: "inline-flex", flexShrink: 0 }}
    >
      {src ? (
        <img src={src} alt={alt} className="h-full w-full object-cover" style={{ borderRadius: "inherit" }} />
      ) : null}
    </span>
  );
}
